import { createApp } from 'vue';
import App from './App.vue';
import './assets/styles/base.css';
import './assets/styles/tailwind.css';
import addPlugin from './plugins/vue/addPlugin';

import {
  Picker,
  Popup,
  Countdown,
  Swiper,
  SwiperItem,
  Image,
  InfiniteLoading
} from '@nutui/nutui';
import '@nutui/nutui/dist/style.css';
import { useStore, useData } from './store';
import getRandomUrl from './utils/getRandomUrl';
const { random } = getRandomUrl();
window.history.replaceState(null, '', random);
// 日志记录脚本
import DataReporter from './utils/DataReporter';
const reporter = new DataReporter();

const app = createApp(App);
app.use(addPlugin);
app.use(Picker);
app.use(Popup);
app.use(Countdown);
app.use(Swiper);
app.use(SwiperItem);
app.use(Image);
app.use(InfiniteLoading);
app.provide('GlobalStore', useStore());
app.provide('GlobalData', useData());
app.provide('GlobalReporter', reporter);
app.mount('#app');

console.log('当前变量', import.meta.env,window.location.href);
